import { axiosInstance } from '../../../core/services/helpers/axios';

const billingConfig = {
    integration: 'dropin',
};

// Calls your server endpoints
// TODO remove if possible
export default async function callServer(url: string, data = {}): Promise<any> {
    const res = await axiosInstance.post(
        url,
        { ...data, adyen_integration: billingConfig.integration },
        {
            // This used to be a raw fetch, which never rejects on an HTTP error status: business
            // failures (refused card, errorCode...) flowed into handleServerResponse, which turns
            // them into a localized message. Keep that, whatever status Billing uses for them.
            // 401 is the exception: it must reject so the response interceptor renews the token
            // and replays the call, instead of failing a payment on an expired token.
            validateStatus: (status) => status !== 401,
        },
    );

    // Callers destructure `{ data }` out of the response *body*, not out of the AxiosResponse.
    return res.data;
}
